<template lang="pug">
    .column
        .card
            header.card-header
                a.card-header-icon(@click="isCollapsed = !isCollapsed")
                    font-awesome-icon(v-if="isCollapsed" class="plus" icon="plus")
                    font-awesome-icon(v-if="!isCollapsed" class="minus" icon="minus")
                    p.card-header-title {{panel.title}}
            .card-content(:class="{'is-hidden':isCollapsed }")
                div(v-if="!isCollapsed" v-html="panel.text")
</template>

<script>

import _ from 'lodash'

export default {
    name: 'Panel',
    mounted() {
        if (this.id) {
          const state = this.getCollapseState();
          if (state) {
            this.isCollapsed = state[this.id];
          }
        }
    },
    data() {
        return {
            delay: 150,
            mouseover: false,
            isCollapsed: true,
        }
    },
    props: {
        panel: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    computed: {
        image() {
            const image = _.get(this.panel, 'images.0')
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            if (w && h) {
                const aspectRatio = 21 / 30

                h = 320
                w = h * aspectRatio
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${w}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${h}`)
            } else if (! w && ! h) {
                h = 320
                w = h * aspectRatio
                fit += `&h=${h}&w=${w}`
            }

            return {
                h,
                w,
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        hyperlink() {
            return _.get(this.panel, 'hyperlink') || {}
        },
        href() {
            let href = false

            if (this.hyperlink.type !== 'internal' && _.get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! _.startsWith(link, 'https://') && ! _.startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return _.get(this.hyperlink, 'target') || '_self'
        },
        path() {
            if (this.hyperlink.type === 'internal' && _.get(this.hyperlink, 'menuItem.path')) return this.hyperlink.menuItem.path
            else return false
        },
        odd() {
          return this.index % 2 == 0;
        }
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        }
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'
    .accordion
        .panel
            position: relative
            overflow: hidden
            .column
            +desktop
                width: 50%
                float: left
            &.hover
                .content .image
                    transform: scale(1.06)
            .panel
                padding: 3px
            .card-header-icon.button
                margin: 0.75rem
            .card-header-title
                font-weight: 500
            .card
                margin: 0rem
            .panel.odd .content
                flex-direction: row-reverse
                .headings
                    flex-grow: 1
                    padding: 15px 25px
                    flex-direction: column
                    justify-content: flex-end
                    display: flex
                    align-items: flex-end
            .card
                border-bottom: 1px solid #0a0a0a1a
                box-shadow: none
                word-break: break-word
                .card-header
                    box-shadow: none
                    .card-header-icon
                        border: none
                        .plus
                            color: #80bb3d
                        .minus
                            color: #bb3d3d
            .content
                height: 350px
                padding: 15px
                // text-shadow: 0 1px 3px #333333
                display: flex
                flex-direction: row
                justify-content: flex-end
                transform-origin: 30% 50% 0
                // background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.3) 75%)
                background: #ebf6cb
                .image
                    transition: transform .3s ease
                    background: $skeletonColor
                .headings
                    flex-grow: 1
                    padding: 15px 25px
                    flex-direction: column
                    justify-content: flex-end
                    display: flex
                    align-items: flex-start
                h2, h4

                    margin: 0
                    padding: 0
                h4
                    text-transform: uppercase
                    font-size: .75rem
                    margin-top: 15px
                h2
                    color: #80bb3d
                    font-size: 1.4rem
                    font-weight: 300
</style>
